/**
 * HDL / hype release limits — products tagged `hype_product`
 * REQ1: 1 qty per product (all variants) per cart
 * REQ2: Only one hype release item in cart at a time (`hype_product` tag; props `_hdl_release`, `_hdl_pid`)
 * REQ3: Logged-in: block repurchase from qualifying paid orders (`theme.hdl.purchasedProductIds`) and same-release drops (`theme.hdl.purchasedHdlReleaseIds` + `custom.hdl_release_id` metafield)
 * REQ4: Guest must log in before add to cart
 */

(function () {
  const HYPE_LIMIT = 1;

  let hdlPdpRefresh = null;

  function getHdl() {
    return (window.theme && window.theme.hdl) || {};
  }

  function str(key, fallback) {
    const s = window.theme && window.theme.strings;
    return (s && s[key]) || fallback;
  }

  function buildHdlCartLoginUrl() {
    let base = getHdl().loginUrl || '/account/login';
    let path = typeof window.location.pathname === 'string' ? window.location.pathname : '/cart';
    if (
      path === '/challenge' ||
      path === '/account/login' ||
      path.indexOf('/account/login') === 0
    ) {
      path = '/';
    }
    path = path + (window.location.search || '');
    const qp = 'return_url=' + encodeURIComponent(path || '/cart') + '&open_cart=true';
    if (base.indexOf('?') >= 0) {
      return base + (base.endsWith('?') || base.endsWith('&') ? '' : '&') + qp;
    }
    return base + '?' + qp;
  }

  function showCheckoutGuestToast() {
    const prev = document.querySelector('.hype-limit-toast');
    if (prev) prev.remove();

    const wrap = document.createElement('div');
    wrap.className = 'hype-limit-toast hype-limit-toast--checkout-gate';
    wrap.setAttribute('role', 'alert');

    const content = document.createElement('div');
    content.className = 'hype-limit-toast__content hype-limit-toast__content--checkout-gate';

    const badge = document.createElement('span');
    badge.className = 'hype-limit-toast__badge';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = '!';

    const col = document.createElement('div');
    col.className = 'hype-limit-toast__col';

    const msgP = document.createElement('p');
    msgP.className = 'hype-limit-toast__msg';
    msgP.textContent = str(
      'hdlCheckoutGuestToast',
      'Please log in to purchase this release item.'
    );

    const loginA = document.createElement('a');
    loginA.className = 'hype-limit-toast__login';
    loginA.href = buildHdlCartLoginUrl();
    loginA.textContent = str('hdlCartToastLogin', 'Log in');

    col.appendChild(msgP);
    col.appendChild(loginA);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hype-limit-toast__close';
    btn.setAttribute('aria-label', str('hdlGuestAlertDismiss', 'Close'));
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    content.appendChild(badge);
    content.appendChild(col);
    content.appendChild(btn);

    wrap.appendChild(content);
    document.body.appendChild(wrap);

    btn.addEventListener('click', function () {
      wrap.remove();
    });
    setTimeout(function () {
      if (wrap.parentElement) wrap.remove();
    }, 8000);
  }

  /**
   * Guest session: prefer documentElement template classes (updated on navigation after logout).
   * theme.hdl.loggedIn alone only matches initial server render.
   */
  function hdlGuestSessionNow() {
    const root = document.documentElement;
    if (root && root.classList.contains('template-customer-logged-out')) return true;
    if (root && root.classList.contains('template-customer-logged-in')) return false;
    return !getHdl().loggedIn;
  }

  /** Guest + hype release in cart: keep checkout button label, intercept and show toast (cart drawer / cart page). */
  function initGuestHypeCheckoutGate() {
    document.addEventListener(
      'click',
      function (e) {
        if (!hdlGuestSessionNow()) return;
        const el = e.target.closest('[data-hdl-guest-checkout="true"]');
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showCheckoutGuestToast();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        if (!hdlGuestSessionNow()) return;
        const form = e.target;
        if (!form || form.id !== 'cartform') return;
        let sub = e.submitter;
        if (!sub && typeof document.activeElement !== 'undefined') {
          const ae = document.activeElement;
          if (ae && ae.getAttribute && ae.getAttribute('name') === 'checkout') sub = ae;
        }
        if (!sub || sub.name !== 'checkout') return;
        if (!sub.dataset || String(sub.dataset.hdlGuestCheckout || '') !== 'true') return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showCheckoutGuestToast();
      },
      true
    );
  }

  let cartData = null;

  function openCartDrawerFromPdp() {
    var drawer = document.querySelector('cart-drawer.js-cart-drawer') || document.querySelector('.js-cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(null);
      return;
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    var routes = window.theme && window.theme.routes;
    if (!drawer && routes && routes.cart) {
      window.location.assign(routes.cart);
    }
  }

  async function fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      cartData = await response.json();
      return cartData;
    } catch (e) {
      console.warn('Could not fetch cart data');
      return null;
    }
  }

  function isReleaseCartItem(item) {
    const h = getHdl();
    const key = h.releasePropKey || '_hdl_release';
    const val = h.releasePropVal || '1';
    if (!item || !item.properties) return false;
    return String(item.properties[key]) === String(val);
  }

  function getHypeProductIdsInCart(items) {
    const result = {};
    (items || []).forEach(function (item) {
      if (!item || item.product_id == null) return;
      const pid = String(item.product_id);
      if (isReleaseCartItem(item)) result[pid] = true;
    });
    const boot = getHdl().bootstrapCartHypeProductIds || [];
    (items || []).forEach(function (item) {
      if (!item || item.product_id == null) return;
      const pid = String(item.product_id);
      if (result[pid]) return;
      let matchBoot = false;
      for (let i = 0; i < boot.length; i += 1) {
        if (String(boot[i]) === pid) {
          matchBoot = true;
          break;
        }
      }
      if (matchBoot) result[pid] = true;
    });
    return Object.keys(result);
  }

  function cartHasOtherHypeProduct(items, currentHypePid) {
    if (currentHypePid == null || currentHypePid === '') return false;
    return getHypeProductIdsInCart(items).some(function (id) {
      return String(id) !== String(currentHypePid);
    });
  }

  function getProductCartQuantity(productId) {
    if (!cartData || !cartData.items || productId == null || productId === '') return 0;
    const pid = String(productId);
    let total = 0;
    cartData.items.forEach(function (item) {
      if (String(item.product_id) === pid) total += item.quantity;
    });
    return total;
  }

  function getHypeProductId() {
    const el = document.querySelector('[data-is-hype-product="true"]');
    return el && el.dataset.hypeProductId ? el.dataset.hypeProductId : null;
  }

  function getOtherHypeProductQty(productId, excludeInput) {
    let total = 0;
    document.querySelectorAll('.cart-item[data-is-hype="true"][data-product-id="' + productId + '"]').forEach(function (el) {
      const inp = el.querySelector('.cart-item__quantity-input');
      if (inp && inp !== excludeInput) total += parseInt(inp.value, 10) || 0;
    });
    return total;
  }

  function parseCartAddPayload(body) {
    const out = {
      items: [],
      hasReleaseProp: false,
      hdlProductId: null,
      hdlReleaseId: null,
    };
    if (!body) return out;

    const h = getHdl();
    const releaseKey = h.releasePropKey || '_hdl_release';
    const releaseVal = String(h.releasePropVal || '1');

    function checkProps(props) {
      if (!props || typeof props !== 'object' || Array.isArray(props)) return;
      if (props[releaseKey] !== undefined && String(props[releaseKey]) === releaseVal) out.hasReleaseProp = true;
      if (props._hdl_pid !== undefined && props._hdl_pid !== null && String(props._hdl_pid) !== '') {
        out.hdlProductId = String(props._hdl_pid);
      }
      if (props._hdl_rid !== undefined && props._hdl_rid !== null && String(props._hdl_rid).trim() !== '') {
        out.hdlReleaseId = String(props._hdl_rid).trim();
      }
    }

    try {
      if (body instanceof FormData) {
        body.forEach(function (value, key) {
          const k = String(key);
          const v = String(value);
          if (k.indexOf(releaseKey) !== -1 && v === releaseVal) out.hasReleaseProp = true;
          if (k.indexOf('_hdl_pid') !== -1 && v !== '') out.hdlProductId = v;
          if (k.indexOf('_hdl_rid') !== -1 && v.trim() !== '') out.hdlReleaseId = v.trim();
        });
        const id = body.get('id');
        const qty = parseInt(body.get('quantity') || '1', 10) || 1;
        if (id) out.items.push({ id: String(id), quantity: qty });
        return out;
      }
      if (typeof body === 'string') {
        let json;
        try {
          json = JSON.parse(body);
        } catch (e1) {
          const params = new URLSearchParams(body);
          params.forEach(function (value, key) {
            const k = String(key);
            const v = String(value);
            if (k.indexOf(releaseKey) !== -1 && v === releaseVal) out.hasReleaseProp = true;
            if (k.indexOf('_hdl_pid') !== -1 && v !== '') out.hdlProductId = v;
            if (k.indexOf('_hdl_rid') !== -1 && v.trim() !== '') out.hdlReleaseId = v.trim();
          });
          const id = params.get('id');
          const qty = parseInt(params.get('quantity') || '1', 10) || 1;
          if (id) out.items.push({ id: String(id), quantity: qty });
          return out;
        }
        if (json.items && Array.isArray(json.items)) {
          json.items.forEach(function (row) {
            out.items.push({
              id: String(row.id),
              quantity: parseInt(row.quantity, 10) || 1,
            });
            checkProps(row.properties);
          });
        } else {
          if (json.properties) checkProps(json.properties);
          if (json.id) out.items.push({ id: String(json.id), quantity: parseInt(json.quantity, 10) || 1 });
        }
        return out;
      }
    } catch (e) {
      /* ignore */
    }
    return out;
  }

  function getHypeReleaseIdFromDom() {
    const el = document.querySelector('[data-is-hype-product="true"]');
    if (!el || el.dataset.hdlReleaseId == null || String(el.dataset.hdlReleaseId).trim() === '') return '';
    return String(el.dataset.hdlReleaseId).trim();
  }

  function alreadyPurchasedHdlRelease(releaseId) {
    const h = getHdl();
    if (!h.loggedIn || !releaseId || String(releaseId).trim() === '') return false;
    const rid = String(releaseId).trim();
    const ids = h.purchasedHdlReleaseIds || [];
    return ids.some(function (x) {
      return String(x).trim() === rid;
    });
  }

  function alreadyPurchasedCurrentRelease() {
    return alreadyPurchasedHdlRelease(getHypeReleaseIdFromDom());
  }

  function alreadyPurchasedCurrentProduct(hypeProductId) {
    const h = getHdl();
    if (!h.loggedIn || !hypeProductId) return false;
    const ids = h.purchasedProductIds || [];
    const pid = parseInt(hypeProductId, 10);
    return ids.some(function (x) {
      return parseInt(x, 10) === pid;
    });
  }

  function showToast(message, variant) {
    const existing = document.querySelector('.hype-limit-toast');
    if (existing) existing.remove();

    const notification = document.createElement('div');
    notification.className = 'hype-limit-toast' + (variant ? ' hype-limit-toast--' + variant : '');
    notification.innerHTML =
      '<div class="hype-limit-toast__content">' +
      '<span class="hype-limit-toast__icon">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 7C12.5523 7 13 7.44772 13 8V8.01C13 8.56228 12.5523 9.01 12 9.01C11.4477 9.01 11 8.56228 11 8.01V8C11 7.44772 11.4477 7 12 7ZM12 10.5C12.5523 10.5 13 10.9477 13 11.5V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11.5C11 10.9477 11.4477 10.5 12 10.5Z" fill="currentColor"/></svg>' +
      '</span>' +
      '<span class="hype-limit-toast__text"></span>' +
      '<button type="button" class="hype-limit-toast__close" aria-label="Close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button></div>';
    notification.querySelector('.hype-limit-toast__text').textContent = message;
    document.body.appendChild(notification);
    notification.querySelector('.hype-limit-toast__close').addEventListener('click', function () {
      notification.remove();
    });
    setTimeout(function () {
      if (notification.parentElement) notification.remove();
    }, 6000);
  }

  function showLimitMessage(kind) {
    if (kind === 'login') {
      showToast(str('hdlLoginRequired', 'Please log in to purchase this release item.'));
      return;
    }
    if (kind === 'one_release') {
      showToast(str('hdlOneReleasePerOrder', 'You may only purchase 1 release item per order.'));
      return;
    }
    if (kind === 'purchased') {
      showToast(str('hdlAlreadyPurchased', 'You already purchased this release item.'));
      return;
    }
    showToast(str('hdlPairLimitAlert', 'Limited to 1 pair per customer for this release'));
  }

  async function validateCartAdd(options) {
    const parsed = parseCartAddPayload(options && options.body);
    const addingRelease = parsed.hasReleaseProp;
    const hypePid = parsed.hdlProductId || getHypeProductId();

    if (addingRelease && !getHdl().loggedIn) {
      showLimitMessage('login');
      throw new Error('HDL login required');
    }

    await fetchCartData();
    const items = (cartData && cartData.items) || [];

    if (addingRelease) {
      const cartHypeIds = getHypeProductIdsInCart(items);
      if (cartHypeIds.length >= 1) {
        if (!hypePid) {
          showLimitMessage('one_release');
          throw new Error('HDL one hype product per cart');
        }
        const conflict = cartHypeIds.some(function (id) {
          return String(id) !== String(hypePid);
        });
        if (conflict) {
          showLimitMessage('one_release');
          throw new Error('HDL one hype product per cart');
        }
      }

      if (
        hypePid &&
        (parsed.hdlProductId || document.querySelector('[data-is-hype-product="true"]'))
      ) {
        if (alreadyPurchasedCurrentProduct(hypePid)) {
          showLimitMessage('purchased');
          throw new Error('HDL already purchased');
        }
        const addingReleaseId =
          (parsed.hdlReleaseId && String(parsed.hdlReleaseId).trim()) || getHypeReleaseIdFromDom();
        if (alreadyPurchasedHdlRelease(addingReleaseId)) {
          showLimitMessage();
          throw new Error('HDL release already purchased');
        }
        const cartQty = getProductCartQuantity(hypePid);
        let addQty = 0;
        parsed.items.forEach(function (row) {
          addQty += row.quantity || 1;
        });
        if (!parsed.items.length) addQty = 1;
        if (cartQty + addQty > HYPE_LIMIT) {
          showLimitMessage();
          throw new Error('HDL quantity limit');
        }
      }

      if (parsed.items.length) {
        let totalAdd = 0;
        parsed.items.forEach(function (row) {
          totalAdd += row.quantity || 1;
        });
        if (totalAdd > HYPE_LIMIT) {
          showLimitMessage();
          throw new Error('HDL quantity limit');
        }
      }
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    const opts = options || {};
    const urlStr = typeof url === 'string' ? url : url && url.url;
    if (urlStr && urlStr.indexOf('/cart/add') !== -1) {
      return validateCartAdd(opts).then(function () {
        return originalFetch.call(window, url, opts);
      });
    }
    return originalFetch.call(window, url, opts);
  };

  function initCartLimit() {
    document.querySelectorAll('.cart-item[data-is-hype="true"]').forEach(function (item) {
      const productId = item.dataset.productId;
      const input = item.querySelector('.cart-item__quantity-input');
      const plusBtn = item.querySelector('.quantity-up');
      if (!input || !productId) return;

      const others = getOtherHypeProductQty(productId, input);
      const maxForLine = Math.max(0, HYPE_LIMIT - others);
      const currentQty = parseInt(input.value, 10) || 0;
      const maxAttr = Math.max(maxForLine, currentQty);
      input.setAttribute('max', maxAttr);

      if (plusBtn) {
        if (currentQty >= maxForLine) {
          plusBtn.classList.add('hype-limit-disabled');
          plusBtn.setAttribute('data-hype-disabled', 'true');
        } else {
          plusBtn.classList.remove('hype-limit-disabled');
          plusBtn.removeAttribute('data-hype-disabled');
        }
      }
    });
  }

  function handleCartQuantityChange(e) {
    const input = e.target;
    if (!input.classList.contains('cart-item__quantity-input')) return;
    const cartItem = input.closest('.cart-item');
    if (!cartItem || cartItem.dataset.isHype !== 'true') return;

    const productId = cartItem.dataset.productId;
    if (!productId) return;

    const newQty = parseInt(input.value, 10) || 0;
    const others = getOtherHypeProductQty(productId, input);
    const maxForLine = Math.max(0, HYPE_LIMIT - others);

    if (newQty > maxForLine) {
      input.value = maxForLine;
      showLimitMessage();
      e.preventDefault();
      e.stopPropagation();
    }

    const plusBtn = cartItem.querySelector('.quantity-up');
    const effectiveQty = parseInt(input.value, 10) || 0;
    if (plusBtn) {
      if (effectiveQty >= maxForLine) {
        plusBtn.classList.add('hype-limit-disabled');
        plusBtn.setAttribute('data-hype-disabled', 'true');
      } else {
        plusBtn.classList.remove('hype-limit-disabled');
        plusBtn.removeAttribute('data-hype-disabled');
      }
    }
    initCartLimit();
  }

  function handleCartQuantityClick(e) {
    const btn = e.target.closest('.quantity-up');
    if (!btn) return;
    if (btn.dataset.hypeDisabled === 'true' || btn.classList.contains('hype-limit-disabled')) {
      e.preventDefault();
      e.stopPropagation();
      showLimitMessage();
      return false;
    }
    const cartItem = btn.closest('.cart-item');
    if (!cartItem || cartItem.dataset.isHype !== 'true') return;
    const input = cartItem.querySelector('.cart-item__quantity-input');
    if (!input) return;
    const productId = cartItem.dataset.productId;
    if (!productId) return;
    const others = getOtherHypeProductQty(productId, input);
    const maxForLine = Math.max(0, HYPE_LIMIT - others);
    const currentQty = parseInt(input.value, 10) || 0;
    if (currentQty >= maxForLine) {
      e.preventDefault();
      e.stopPropagation();
      showLimitMessage();
      return false;
    }
  }

  async function initPDPLimit() {
    const productForm = document.querySelector('[data-is-hype-product="true"]');
    if (!productForm) {
      hdlPdpRefresh = null;
      return;
    }

    await fetchCartData();

    const buyForm =
      productForm.querySelector('buy-buttons form.js-product-form') ||
      productForm.querySelector('form.js-product-form') ||
      productForm.querySelector('form[action*="/cart/add"]') ||
      productForm.querySelector('form');
    if (!buyForm) return;

    const qtyInput = buyForm.querySelector('input[name="quantity"]');
    const variantInput = buyForm.querySelector('input[name="id"]') || buyForm.querySelector('select[name="id"]');
    const addToCartBtn =
      buyForm.querySelector('button[type="submit"][name="add"]') ||
      buyForm.querySelector('button.add-to-cart[type="submit"]') ||
      buyForm.querySelector('.add-to-cart');

    function getStickyAtcButton() {
      var sticky = document.querySelector('sticky-atc');
      if (!sticky) return null;
      return sticky.querySelector('button[type="submit"][name="add"]') || sticky.querySelector('button.add-to-cart');
    }

    function forEachAtcButton(fn) {
      var seen = [];
      if (addToCartBtn) {
        seen.push(addToCartBtn);
        fn(addToCartBtn);
      }
      var stickyBtn = getStickyAtcButton();
      if (stickyBtn && seen.indexOf(stickyBtn) === -1) {
        fn(stickyBtn);
      }
    }
    const hypeProductId = getHypeProductId();
    const guestMustLogin = !getHdl().loggedIn;
    const purchasedBlock =
      hypeProductId &&
      (alreadyPurchasedCurrentProduct(hypeProductId) || alreadyPurchasedCurrentRelease());

    function clearPdpNotes() {
      document.querySelectorAll('.hype-pdp-limit-note').forEach(function (n) {
        n.remove();
      });
    }

    function insertReleaseStyleAlert(opts) {
      clearPdpNotes();
      const wrap = document.createElement('div');
      wrap.className =
        'hype-pdp-limit-note hype-pdp-limit-note--guest hype-pdp-limit-note--release-limit';
      wrap.setAttribute('role', 'alert');

      const accent = document.createElement('span');
      accent.className = 'hype-pdp-guest-alert__accent';
      accent.setAttribute('aria-hidden', 'true');

      const dismissProp = opts.dismissDatasetProp;
      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'hype-pdp-guest-alert__close';
      closeBtn.setAttribute('aria-label', str('hdlGuestAlertDismiss', 'Dismiss'));
      closeBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M13 1L1 13M1 1l12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', function () {
        if (dismissProp) buyForm.dataset[dismissProp] = 'true';
        wrap.remove();
      });

      const badge = document.createElement('span');
      badge.className = 'hype-pdp-guest-alert__badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">' +
        '<circle cx="11" cy="11" r="8.75" stroke="#c62828" stroke-width="1.25"/>' +
        '<path d="M11 7.2v5.9" stroke="#c62828" stroke-width="1.35" stroke-linecap="round"/>' +
        '<circle cx="11" cy="15.4" r="1.05" fill="#c62828"/>' +
        '</svg>';

      const content = document.createElement('div');
      content.className = 'hype-pdp-guest-alert__content';

      const p = document.createElement('p');
      p.className = 'hype-pdp-guest-alert__text';
      if (opts.inlineLinks && opts.inlineLinks.length) {
        p.appendChild(document.createTextNode(String(opts.message).replace(/\s+$/, '') + ' '));
        opts.inlineLinks.forEach(function (linkSpec) {
          const a = document.createElement('a');
          a.className = linkSpec.linkClass || 'hype-pdp-guest-alert__signin';
          a.href = linkSpec.href || '#';
          a.textContent = linkSpec.label;
          if (linkSpec.onClick) {
            a.addEventListener('click', function (e) {
              e.preventDefault();
              linkSpec.onClick(e);
            });
          }
          p.appendChild(a);
        });
      } else {
        p.textContent = opts.message;
      }

      content.appendChild(p);
      (opts.footerElements || []).forEach(function (el) {
        content.appendChild(el);
      });

      wrap.appendChild(accent);
      wrap.appendChild(closeBtn);
      wrap.appendChild(badge);
      wrap.appendChild(content);

      const buyButtonsRow =
        addToCartBtn &&
        (addToCartBtn.closest('.quantity-submit-row') ||
          addToCartBtn.closest('.buy-buttons-row') ||
          addToCartBtn.parentElement);
      if (buyButtonsRow && buyButtonsRow.parentElement) {
        buyButtonsRow.parentElement.insertBefore(wrap, buyButtonsRow);
      }
    }

    function insertGuestLoginAlert(loginUrl) {
      const loginUrlResolved = loginUrl || '/account/login';
      const signIn = document.createElement('a');
      signIn.className = 'hype-pdp-guest-alert__signin';
      signIn.href =
        loginUrlResolved +
        (loginUrlResolved.indexOf('?') >= 0 ? '&' : '?') +
        'return_url=' +
        encodeURIComponent(window.location.pathname + window.location.search);
      signIn.textContent = str('hdlSignIn', 'Sign in');

      insertReleaseStyleAlert({
        message: str('hdlGuestSignInAlert', 'Please sign in to purchase this release.'),
        dismissDatasetProp: 'hdlGuestAlertDismissed',
        footerElements: [signIn],
      });
    }

    function updatePDPState() {
      if (!variantInput || !hypeProductId) return;

      if (purchasedBlock) {
        if (qtyInput) {
          qtyInput.setAttribute('max', '1');
        }
        forEachAtcButton(function (btn) {
          btn.classList.add('hype-cart-limit-reached', 'hype-pdp-atc--guest', 'hype-pdp-atc--cart-limit');
          btn.setAttribute('disabled', 'disabled');
          if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
          btn.textContent = str('hdlLimitReachedAtc', 'Limit reached for this release');
        });
        if (buyForm.dataset.hdlPurchasedAlertDismissed !== 'true') {
          insertReleaseStyleAlert({
            message: str('hdlPairLimitAlert', 'Limited to 1 pair per customer for this release'),
            dismissDatasetProp: 'hdlPurchasedAlertDismissed',
          });
        }
        return;
      }

      if (guestMustLogin) {
        if (qtyInput) qtyInput.setAttribute('max', '1');
        forEachAtcButton(function (btn) {
          btn.classList.add('hype-cart-limit-reached', 'hype-pdp-atc--guest');
          btn.setAttribute('disabled', 'disabled');
          if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
          btn.textContent = str('hdlSignInToPurchase', 'Sign in to purchase');
        });
        const loginUrl = getHdl().loginUrl || '/account/login';
        if (buyForm.dataset.hdlGuestAlertDismissed !== 'true') {
          insertGuestLoginAlert(loginUrl);
        }
        return;
      }

      buyForm.dataset.hdlGuestAlertDismissed = '';

      const cartQty = getProductCartQuantity(hypeProductId);
      const cartHasOtherHype = cartHasOtherHypeProduct((cartData && cartData.items) || [], hypeProductId);

      if (cartQty < HYPE_LIMIT) buyForm.dataset.hdlCartLimitAlertDismissed = '';
      if (!cartHasOtherHype) buyForm.dataset.hdlCrossReleaseAlertDismissed = '';

      const inputQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      const availableQty = Math.max(0, HYPE_LIMIT - cartQty);

      if (qtyInput) {
        qtyInput.setAttribute('max', availableQty || HYPE_LIMIT);
        if (inputQty > availableQty && availableQty > 0) qtyInput.value = availableQty;
        else if (availableQty === 0 && inputQty > 0) qtyInput.value = 1;
      }

      if (addToCartBtn || getStickyAtcButton()) {
        if (cartQty >= HYPE_LIMIT) {
          forEachAtcButton(function (btn) {
            btn.classList.add('hype-cart-limit-reached', 'hype-pdp-atc--guest', 'hype-pdp-atc--cart-limit');
            btn.setAttribute('disabled', 'disabled');
            if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
            btn.textContent = str('hdlLimitReachedAtc', 'Limit reached for this release');
          });
          if (buyForm.dataset.hdlCartLimitAlertDismissed !== 'true') {
            insertReleaseStyleAlert({
              message: str('hdlPairLimitAlert', 'Limited to 1 pair per customer for this release'),
              dismissDatasetProp: 'hdlCartLimitAlertDismissed',
            });
          }
        } else if (cartHasOtherHype) {
          forEachAtcButton(function (btn) {
            btn.classList.add('hype-cart-limit-reached', 'hype-pdp-atc--guest', 'hype-pdp-atc--cart-limit');
            btn.setAttribute('disabled', 'disabled');
            if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
            btn.textContent = str('hdlLimitReachedAtc', 'Limit reached for this release');
          });
          if (buyForm.dataset.hdlCrossReleaseAlertDismissed !== 'true') {
            insertReleaseStyleAlert({
              message: str('hdlOneReleasePerOrder', 'You may only purchase 1 release item per order.'),
              dismissDatasetProp: 'hdlCrossReleaseAlertDismissed',
              inlineLinks: [
                {
                  label: str('hdlUpdateCart', 'Update Cart'),
                  onClick: openCartDrawerFromPdp,
                },
              ],
            });
          }
        } else {
          clearPdpNotes();
          forEachAtcButton(function (btn) {
            btn.classList.remove('hype-cart-limit-reached', 'hype-pdp-atc--guest', 'hype-pdp-atc--cart-limit');
            btn.removeAttribute('disabled');
            if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
          });
        }
      }
    }

    hdlPdpRefresh = function () {
      updatePDPState();
    };

    updatePDPState();

    if (productForm.dataset.hdlPdpListeners === 'true') return;
    productForm.dataset.hdlPdpListeners = 'true';

    var stickyBuyForm = document.querySelector('sticky-atc form.js-product-form');
    if (variantInput) {
      const observer = new MutationObserver(function () {
        updatePDPState();
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', updatePDPState);
    }

    document.addEventListener(
      'on:variant:change',
      async function () {
        await fetchCartData();
        updatePDPState();
      },
      false
    );

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        const cartQty = hypeProductId ? getProductCartQuantity(hypeProductId) : 0;
        let cap = Math.max(0, HYPE_LIMIT - cartQty);
        const items = (cartData && cartData.items) || [];
        if (cartHasOtherHypeProduct(items, hypeProductId)) cap = 0;
        if (parseInt(this.value, 10) > cap && cap >= 0) {
          this.value = Math.max(1, cap || 1);
          if (cap === 0) showLimitMessage('one_release');
        }
      });
      qtyInput.addEventListener('input', function () {
        const cartQty = hypeProductId ? getProductCartQuantity(hypeProductId) : 0;
        let cap = Math.max(0, HYPE_LIMIT - cartQty);
        const items = (cartData && cartData.items) || [];
        if (cartHasOtherHypeProduct(items, hypeProductId)) cap = 0;
        if (parseInt(this.value, 10) > cap && cap >= 0) {
          this.value = Math.max(1, cap || 1);
        }
      });
    }

    const wrapper = buyForm.querySelector('quantity-wrapper');
    if (wrapper && qtyInput) {
      wrapper.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-quantity="up"]');
        if (!btn) return;
        setTimeout(function () {
          const cartQty = hypeProductId ? getProductCartQuantity(hypeProductId) : 0;
          let availableQty = Math.max(0, HYPE_LIMIT - cartQty);
          const items = (cartData && cartData.items) || [];
          if (cartHasOtherHypeProduct(items, hypeProductId)) availableQty = 0;
          if (parseInt(qtyInput.value, 10) > availableQty) {
            qtyInput.value = Math.max(1, availableQty);
            showLimitMessage(availableQty === 0 ? 'one_release' : undefined);
          }
        }, 10);
      });
    }

    if (!guestMustLogin && !purchasedBlock) {
      forEachAtcButton(function (btn) {
        btn.addEventListener(
          'click',
          async function (e) {
            await fetchCartData();
            const items = (cartData && cartData.items) || [];
            if (cartHasOtherHypeProduct(items, hypeProductId)) {
              e.preventDefault();
              e.stopImmediatePropagation();
              showLimitMessage('one_release');
              updatePDPState();
              return false;
            }
          },
          true
        );
      });
    }

    async function handleHdlProductSubmit(e) {
      if (guestMustLogin || purchasedBlock) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (guestMustLogin) showLimitMessage('login');
        else showLimitMessage();
        return false;
      }
      await fetchCartData();
      const variantId = variantInput ? variantInput.value : null;
      if (!variantId || !hypeProductId) return;

      const cartQty = getProductCartQuantity(hypeProductId);
      const inputQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      const items = (cartData && cartData.items) || [];

      if (cartHasOtherHypeProduct(items, hypeProductId)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showLimitMessage('one_release');
        return false;
      }

      if (cartQty >= HYPE_LIMIT) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showLimitMessage();
        return false;
      }
      if (cartQty + inputQty > HYPE_LIMIT) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (qtyInput) qtyInput.value = Math.max(1, HYPE_LIMIT - cartQty);
        showLimitMessage();
        return false;
      }
    }

    buyForm.addEventListener('submit', handleHdlProductSubmit, true);
    if (stickyBuyForm && stickyBuyForm !== buyForm) {
      stickyBuyForm.addEventListener('submit', handleHdlProductSubmit, true);
    }
  }

  function observeCartChanges() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) initCartLimit();
      });
    });
    document.querySelectorAll('cart-form, .cart-item-list, .cart-drawer').forEach(function (container) {
      if (container) observer.observe(container, { childList: true, subtree: true });
    });
  }

  async function init() {
    await initPDPLimit();
    initGuestHypeCheckoutGate();
    initCartLimit();
    observeCartChanges();

    document.addEventListener('change', handleCartQuantityChange, true);
    document.addEventListener('click', handleCartQuantityClick, true);

    document.addEventListener('dispatch:cart-drawer:open', function () {
      setTimeout(initCartLimit, 100);
    });

    document.addEventListener('on:cart:change', async function () {
      await fetchCartData();
      initCartLimit();
      if (hdlPdpRefresh) hdlPdpRefresh();
    });

    document.addEventListener('on:cart:after-merge', async function () {
      await fetchCartData();
      initCartLimit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
